import { useBreakpoints } from 'react-breakpoints-hook'
import { MultipleCarousel } from '@components/pages/franquias/carousel'
import { TextBase } from '@components/v2/text-base'
import { Title } from '@components/v2/title'
import { Button } from '@components/v2/button'

import styles from './styles.module.scss'

interface Props {
  smoothScroll?: () => void
}

export const SectionFreeMarketAdvantages = ({ smoothScroll }: Props) => {
  const { sm } = useBreakpoints({
    sm: { min: 1, max: 767 },
    md: { min: 768, max: null }
  })

  const imagesCarousel = [
    {
      key: 'competitividade',
      title: 'Competitividade',
      description: (
        <>
          O <strong>Portal Solar</strong> trabalha com foco total na redução de
          gastos com eletricidade da sua empresa, tornando-a mais competitiva no
          mercado em seu ramo de atuação.
        </>
      ),
      imageUrl: sm
        ? '/assets/mobile/vantagens-mercado-livre-de-energia-eletrica.webp'
        : '/assets/desktop/vantagens-mercado-livre-de-energia-eletrica.webp'
    },
    {
      key: 'sustentabilidade',
      title: 'Sustentabilidade',
      description: (
        <>
          Te ajudamos a promover a sustentabilidade na sua empresa com a escolha
          de fornecedores no <strong>mercado livre</strong> que atuam com fontes
          renováveis ou até mesmo com soluções em projetos de geração solar
          fotovoltaica para que você se torne um autoprodutor de energia limpa!
        </>
      ),
      imageUrl: sm
        ? '/assets/mobile/vantagens-ambiente-de-contrataçao-livre.webp'
        : '/assets/desktop/vantagens-ambiente-de-contrataçao-livre.webp'
    },
    {
      key: 'economia',
      title: 'Economia',
      description: (
        <>
          A principal vantagem em aderir ao <strong>mercado livre</strong> é a
          redução de custos com energia elétrica. A equipe de especialistas do
          Portal Solar construirá a melhor estratégia para contratar a sua
          energia!
        </>
      ),
      imageUrl: sm
        ? '/assets/mobile/economia-de-energia-mercado-livre.webp'
        : '/assets/desktop/economia-de-energia-mercado-livre.webp'
    },
    {
      key: 'previsibilidade',
      title: 'Previsibilidade Orçamentária',
      description: (
        <>
          Com os preços da sua energia estipulados durante toda a vigência do
          contrato, você garante previsibilidade e fica menos exposto aos
          aumentos da tarifa, além de contar com a ajuda de nossos especialistas
          na elaboração de orçamentos anuais.
        </>
      ),
      imageUrl: sm
        ? '/assets/mobile/mercado-livre-de-energia-vantagens.webp'
        : '/assets/desktop/mercado-livre-de-energia-vantagens.webp'
    },
    {
      key: 'poder',
      title: 'Poder de Escolha',
      description: (
        <>
          No <strong>mercado livre</strong> você pode escolher o seu fornecedor
          de energia, nossa equipe está preparada para buscar neste mercado as
          melhores oportunidades de negócio, proporcionando um serviço
          especializado, com transparência e segurança.
        </>
      ),
      imageUrl: sm
        ? '/assets/mobile/ambiente-de-contrataçao-livre-vantagens.webp'
        : '/assets/desktop/ambiente-de-contrataçao-livre-vantagens.webp'
    }
  ]

  const renderImageCard = (block: any) => {
    return (
      <div
        className={styles.item}
        style={{
          backgroundImage: `url(${block.imageUrl})`
        }}
      >
        <Title className="font-semibold" level="h3">
          {block.title}
        </Title>
        <TextBase className="font-light">{block.description}</TextBase>
      </div>
    )
  }

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.headings}>
        <Title className={styles.title} level="h2">
          Quais são as vantagens do <br />
          <span className="text-orange">Mercado Livre de Energia?</span>
        </Title>
        <TextBase className={styles.description}>
          Veja alguns dos benefícios que você obtém no{' '}
          <strong>Mercado Livre.</strong>
        </TextBase>
      </div>

      <MultipleCarousel
        items={imagesCarousel}
        renderComponent={renderImageCard}
        showDots
        mobileBreakpoint={640}
        className={styles.carouselContainer}
        containerStyle={{ paddingBottom: 16, paddingTop: 16 }}
        customResponsive={[
          {
            breakpoint: 800,
            cols: 1,
            gap: 0
          },
          {
            breakpoint: 1280,
            cols: 2,
            gap: 0
          },
          {
            breakpoint: 10000,
            cols: 3,
            gap: 0
          }
        ]}
      />

      <div className="flex justify-center mt-16 lg:mt-32">
        <Button type="button" onClick={smoothScroll}>
          Aproveite as vantagens
        </Button>
      </div>
    </div>
  )
}
